<template>
    <div>
        <van-dialog
                v-model="show"
                :title="auditTitle"
                show-cancel-button
                :before-close="auditConfirm"
                @cancel="show=false"
        >
            <van-field type="text" label="驳回至" v-model="jumpToCn" :error-message="jumpToErr" @click="nodeSelectShow = true" placeholder="点击选择驳回节点" readonly/>

            <van-field type="text" label="流程处理人" v-model="realName" :error-message="realNameErr" @click="processPersonShow" placeholder="点击选择流程处理人" readonly/>

            <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr"
                       placeholder="请输入审批意见"/>

        </van-dialog>

        <van-popup position="bottom" v-model="nodeSelectShow" :overlay="true">

            <van-picker title="请选择驳回环节" show-toolbar :columns="columns"
                        @confirm="onRejectConfirm"
                        @cancel="nodeSelectShow=false"/>

        </van-popup>

        <SysUser></SysUser>
    </div>
</template>

<script>
    import { rejectProcess } from '@/api/loanInfo'
    import { eventBus } from '../../../../../vue/utils/eventBus'
    import { mapGetters } from 'vuex'
    import SysUser from '../../../../component/sys-user'

    export default {
        name: 'mortgage_warrent',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        watch: {
            'jumpTo'(val) {
                if (val == undefined || val.length > 0) {
                    this.jumpToErr = ''
                }
            },
            'remark'(val) {
                if (val == undefined || val.length > 0) {
                    this.remarkErr = ''
                }
            },
            'handleUser'(val) {
                if (val == undefined || val.length > 0) {
                    this.realNameErr = ''
                }
            }
        },
        components: {
            SysUser
        },
        computed: mapGetters([
            'auditStatus',
            'applyInfo',
            'userName',
            'name'
        ]),
        data() {
            return {
                show: false,
                nodeSelectShow: false,
                jumpTo: '',
                jumpToErr: '',
                jumpToCn: '',
                handleUser: '',
                remark: '',
                remarkErr: '',
                auditTitle: '',
                realName: '',
                realNameErr: '',
                columns:['合同签订']
            }
        },
        mounted() {
            let self = this
            //初始化触发事件
            eventBus.$on('reject-loan-dialog', function () {
                self.show = true
                self.auditTitle = '流程驳回'
            })

            //初始化触发事件
            eventBus.$on('selectUser', function (item) {
                self.handleUser = item.userId
                self.realName = item.realName
            })

        },
        destroyed() {
            eventBus.$off('reject-loan-dialog')
            eventBus.$off('selectUser')
        },
        methods: {
            auditConfirm(action, done) {
                if (action === 'confirm') {
                    //验证
                    if (!this.jumpTo) {
                        this.jumpToErr = '请选择驳回环节'
                        done(false)
                        return false
                    }
                    if (!this.handleUser) {
                        this.realNameErr = '请选择流程处理人'
                        done(false)
                        return false
                    }
                    if (!this.remark) {
                        this.remarkErr = '请输入审批意见'
                        done(false)
                        return false
                    }

                    let params = {
                        applyId: this.applyId,
                        jumpTo: this.jumpTo,
                        remark: this.remark,
                        handleUser: this.handleUser
                    }

                    rejectProcess(params).then(res => {
                        done()
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                }else {
                    this.remarkErr = ''
                    done()
                }
            },
            //选择驳回环节
            onRejectConfirm(val, index) {
                this.jumpToCn = this.columns[index]
                if(index == 0){
                    this.jumpTo = 'CONTRACT_GATHER'
                }
                this.nodeSelectShow = false
            },
            conditionalPassChange(val) {

            },
            processPersonShow() {
                eventBus.$emit('sys-user-popup', {title: '选择流程处理人'})
            },
            selectUser(item) {

            }

        }
    }
</script>

<style scoped>

</style>


